import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

// Data da parte literal do ISO (evita shift de timezone).
const formatDate = (iso) => {
  if (!iso || iso.startsWith('1969') || iso.startsWith('1970-01-01'))
    return null;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : null;
};

const statusLabel = (item) => {
  const text = `${item.title || ''} ${(
    item.Subject ||
    item.subjects ||
    []
  ).join(' ')}`.toLocaleLowerCase('pt-BR');
  if (text.includes('cancelad')) return 'Cancelada';
  if (text.includes('encerrad')) return 'Encerrada';
  if (text.includes('abert') || text.includes('andamento')) return 'Aberta';
  return null;
};

// Listing variation DS — só as linhas (título link + data à direita). A faixa
// azul clara e o campo de busca vivem na search variation AgsusListaLayout.
const AgsusListaTemplate = ({ items, isEditMode }) => (
  <ul className="ag-lista__list">
    {items.map((item) => {
      const date = formatDate(item.effective);
      const status = statusLabel(item);
      return (
        <li key={item['@id']} className="ag-lista__item">
          <ConditionalLink item={item} condition={!isEditMode}>
            <span className="ag-lista__item-main">
              <strong className="ag-lista__item-title">
                {item.title || item.id}
              </strong>
              {item.description && (
                <small className="ag-lista__item-description">
                  {item.description}
                </small>
              )}
            </span>
            {(date || status) && (
              <span className="ag-lista__item-meta">
                {date && <span className="ag-lista__item-date">{date}</span>}
                {status && (
                  <mark className="ag-lista__item-status">{status}</mark>
                )}
              </span>
            )}
          </ConditionalLink>
        </li>
      );
    })}
  </ul>
);

AgsusListaTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default AgsusListaTemplate;
